import { render } from "./company-row.vue?vue&type=template&id=994effb8&scoped=true&ts=true&lang=pug"
import script from "./company-row.vue?vue&type=script&lang=ts"
export * from "./company-row.vue?vue&type=script&lang=ts"

import "./company-row.vue?vue&type=style&index=0&id=994effb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-994effb8"]])

export default __exports__